import { onlineManager, type QueryObserverResult } from "@tanstack/react-query"

/**
 * Whether a query that has no answer yet is waiting for the network to return: TanStack Query
 * pauses it while the browser is offline, rather than failing it. For the shell's question of who
 * is signed in, that is when it says "You're offline" in place of its frame (`connection.tsx`).
 */
export const waitingForNetwork = ({
  isPending,
  fetchStatus,
}: Pick<QueryObserverResult, "isPending" | "fetchStatus">) => isPending && fetchStatus === "paused"

/**
 * The offline card's Try again: takes the cache off the browser's word that it is offline, so the
 * queries it holds ask at once. A browser can say it is offline when it isn't (Chromium does behind
 * some VPNs and virtual network adapters), and the card would wait for a return that never comes.
 * Offline in truth, the question fails and the shell says so, with Try again of its own.
 */
export const assumeOnline = () => onlineManager.setOnline(true)
